import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import ButtonCinestar from '../../../../components/Buttons/ButtonCinestar/ButtonCinestar'

import './ChooseHeader.scss'

/**
 * Displays at mobile
 */
const ChooseHeader = ({ isLoginForm, setIsLoginForm }) => {
    const intl = useIntl()

    return (
        <Container fluid className="choose-header">
            <div className="choose-header--option">
                <ButtonCinestar
                    variant={isLoginForm ? 'primary-v2' : 'secondary'}
                    size={'sm'}
                    className={'w-100'}
                    onClick={() => setIsLoginForm(true)}
                >
                    {intl.formatMessage({ id: 'contactInfo.haveAccount' })}
                </ButtonCinestar>
            </div>
            <div className="choose-header--option">
                <ButtonCinestar
                    variant={isLoginForm ? 'secondary' : 'primary-v2'}
                    size={'sm'}
                    className={'w-100'}
                    onClick={() => setIsLoginForm(false)}
                >
                    {intl.formatMessage({ id: 'contactInfo.withoutLogin' })}
                </ButtonCinestar>
            </div>
        </Container>
    )
}

export default ChooseHeader
